import React, { FC, useEffect, useState, useMemo } from 'react'
import { ConfigProvider as AntdConfigProvider } from 'antd'
import { StyleProvider } from '@ant-design/cssinjs'
interface IAntdThemeProviderProps {
  children: React.ReactNode
}

export const AntdThemeProvider: FC<IAntdThemeProviderProps> = ({
  children
}) => {
  return (
    <StyleProvider hashPriority="high">
      <AntdConfigProvider>{children}</AntdConfigProvider>
    </StyleProvider>
  )
}
